"use strict";

module.exports = function abortCb(cb, abort, onAbort) {
  cb(abort);
  onAbort && onAbort(abort === true ? null : abort);
  return;
};